
<div class="scout-point-photo-browser">
    <ng-container *ngIf="photos.length; else noPhotos">
    <div *ngFor="let grpDef of PhotoGroupDefs">
        <div class="d-flex flex-row">
            <div class="scout-point-photo-browser-group-heading"
                [attr.role]="groupSelectEnabled?'button':''" (click)="onPhotoGroupClick(grpDef)">{{grpDef.title}}</div>
            <div class="d-flex flex-wrap w-100">
                <ng-container *ngFor="let photo of photosByGroup[grpDef.name].photos;">
                <button [attr.title]="(photo?.uploadDate?'Uploaded':'Not uploaded') + ', ' + (photo.modifiedDate?'last modified '+ photo.modifiedDate:'not yet saved')"
                    (click.single)="onPhotoIconClick(photo,grpDef)"
                    (dblclick)="photoIconDblClick.next({photo,grpDef,contextByPhotoId})" class="scout-point-photo-browser-btn">
                    <ng-container [ngTemplateOutlet]="photoBtnContentTmplRef||defaultPhotoBtnContentTmplRef"
                        [ngTemplateOutletContext]="{photo,grpDef,context: contextByPhotoId[photo._id]}">
                    </ng-container>
                </button>
                </ng-container>
                <button *ngIf="!locked&&newPhotoFn&&grpDef.name?.match('^(point-to-point|additional)$')"
                    (click)="createGroupPhoto(grpDef)" role="button" title="Add new photo"
                    class="scout-point-photo-browser-btn">
                    <i class="fa fa-plus-circle text-success"></i>
                </button>
            </div>
        </div>
    </div>
    </ng-container>
</div>

<ng-template #defaultPhotoBtnContentTmplRef let-photo="photo" let-context="context">
    <i class="fa" [ngClass]="context?.iconCssClass"
    [ngStyle]="{'background-color': 'rgb(255,255,0,'+photo['bgAlpha']+')'}"></i>
</ng-template>

<ng-template #noPhotos>
    <div *ngIf="isLoadingPhotos">
        <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div *ngIf="!isLoadingPhotos && scoutPoint?.type!='VIA'" class="font-italic text-warning">
        no photos
    </div>
</ng-template>

